import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import LeadsListPage from '../components/LeadsListPage'
import {
  actionCreators,
  ILeadsListState,
  selectDueDate,
  selectError,
  selectFilterText,
  selectIncludeArchived,
  selectIsLoading,
  selectIsLoadingNew,
  selectItemChangedIndex,
  selectItems,
  selectNewItems,
  selectOrderBy,
  selectPriority,
  selectPropertyTypes,
  selectScope,
  selectSince,
  selectSortOrder,
  selectStatus,
  selectTotalItems,
} from '../modules/leadsList'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      ICurrentUserState & ILeadsListState & IGlobalConfigurationState
    >({
      configuration: selectConfiguration(),
      dueDate: selectDueDate(),
      error: selectError(),
      filterText: selectFilterText(),
      includeArchived: selectIncludeArchived(),
      isLoading: selectIsLoading(),
      isLoadingNew: selectIsLoadingNew(),
      itemChangedIndex: selectItemChangedIndex(),
      items: selectItems(),
      newItems: selectNewItems(),
      priority: selectPriority(),
      propertyTypes: selectPropertyTypes(),
      scope: selectScope(),
      since: selectSince(),
      sortOrder: selectSortOrder(),
      orderBy: selectOrderBy(),
      status: selectStatus(),
      totalItems: selectTotalItems(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(LeadsListPage),
)
